import FlexBox from 'components/Shared/Container/FlexBox';
import PropertyField from 'components/Shared/PropertyField';
import ListItem from 'components/Shared/VerifiedPayments/ListItem';
import React from 'react';
import { Collapse } from 'react-collapse';
import { useTranslation } from 'react-i18next';
import styled from 'styled-components';
import { SiteType } from 'types/site.types';
import PaymentsMarker from 'components/Shared/VerifiedPayments/Marker';
import BatchTracing from 'components/Shared/BatchTracingContainer/BatchTracing';
import HtmlField from 'components/Shared/HtmlField';
import FarmSiteListItemContent from './FarmSiteListItemContent';
const Content = styled.div `
  background: #fff;
  padding: 16px;
  font-size: 14px;
`;
const TracingContainer = styled.div `
  margin-bottom: 16px;
`;
const SiteListItem = ({ site, chainStepActivity, ref, isBatchTracingActive, hasOtherIngredients, rawMaterial, selectedSiteId, hideIndicator, isSelectedActivityTraceable, isSelectedStepTraceable, onClick, onOpenSiteBatchDetailsSlide, }) => {
    const { t } = useTranslation();
    const isFarmSite = site.siteType === SiteType.FARM;
    const numberOfFarmers = isFarmSite ? site.numberOfFarmers || 0 : undefined;
    const hasBasicFarmData = isFarmSite &&
        (site.workersSummary ||
            !!site.sizeHa ||
            !!site.productiveSizeHa ||
            typeof site.accessToSanitationFacilities === 'boolean' ||
            typeof site.directAccessToWater === 'boolean');
    return (React.createElement(ListItem, { key: site.id, Icon: PaymentsMarker, image: site.image, title: site.title, hideSubtitle: !numberOfFarmers, subtitle: `${numberOfFarmers} ${t('tracing.farmers')}`, ref: ref, active: selectedSiteId === site.id, onClick: () => onClick(site.id), hideIndicator: hideIndicator },
        React.createElement(Collapse, { isOpened: selectedSiteId === site.id },
            React.createElement(Content, { expanded: selectedSiteId === site.id },
                isBatchTracingActive && (React.createElement(TracingContainer, null,
                    React.createElement(BatchTracing, { chainStepActivity: chainStepActivity, hasOtherIngredients: hasOtherIngredients, batchTracingActive: isBatchTracingActive, rawMaterial: rawMaterial, notTraceableActivity: !isSelectedActivityTraceable, notTraceableStep: !isSelectedStepTraceable, hideLocationPin: true, selectedSiteId: selectedSiteId, isOverview: true, onClick: onOpenSiteBatchDetailsSlide }))),
                isFarmSite && React.createElement(FarmSiteListItemContent, { farmSite: site }),
                site.description && (React.createElement(FlexBox, { gap: 2, mt: hasBasicFarmData ? 2 : 0, flexWrap: "wrap" },
                    React.createElement(PropertyField, { label: isFarmSite ? t('farm-description') : t('site-description'), value: React.createElement(HtmlField, null, site.description) })))))));
};
export default SiteListItem;
